export default __webpack_public_path__ + "static/media/GA.6dae5fe1.ico";